import { FC, ReactNode, createContext, useContext } from 'react';
import { useConfirmModal } from '@/hooks/useConfirmModal';
import ConfirmModal from './ConfirmModal';

interface ConfirmModalContextType {
  confirm: (options: {
    title: string;
    description: string | React.ReactNode;
    continueText?: string;
    cancelText?: string;
    onContinue: () => void;
    onCancel?: () => void;
  }) => void;
}

const ConfirmModalContext = createContext<ConfirmModalContextType | undefined>(undefined);

interface ConfirmModalProviderProps {
  children: ReactNode;
}

export const ConfirmModalProvider: FC<ConfirmModalProviderProps> = ({ children }) => {
  const { confirm, isOpen, options, handleContinue, handleCancel } = useConfirmModal();

  return (
    <ConfirmModalContext.Provider value={{ confirm }}>
      {children}
      <ConfirmModal
        open={isOpen}
        title={options?.title || ''}
        description={options?.description || ''}
        continueText={options?.continueText}
        cancelText={options?.cancelText}
        onContinue={handleContinue}
        onCancel={handleCancel}
      />
    </ConfirmModalContext.Provider>
  );
};

export const useConfirm = () => {
  const context = useContext(ConfirmModalContext);

  if (context === undefined) {
    throw new Error('useConfirm must be used within a ConfirmModalProvider');
  }

  return context;
};
